import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Promocode {{code}} toegepast',
  [COUPON_TYPES.CASHBACK]: 'Loyaliteitspunten toegepast',
  [COUPON_TYPES.REWARD]: 'Beloning toegepast',
  [COUPON_TYPES.GIFT_CARD]: 'Cadeaubon toegepast',
};

export default Coupons;
